import React, { useState } from "react";
import { Button } from "../Button";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { TransportForm } from "./TransportForm";
import { useAddTransport } from "../../hooks/transportHook/transport.hooks";

export const AddTransport = () => {
  const dispatch = useDispatch();
  const [transportCode, setTransportCode] = useState("");
  const [routeName, setRouteName] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [licenseNo, setLicenseNo] = useState("");
  const [driverName, setDriverName] = useState("");
  const [driverContact, setDriverContact] = useState("");

  const onResetTransportForm = () => {
    setTransportCode("");
    setRouteName("");
    setVehicleNo("");
    setLicenseNo("");
    setDriverName("");
    setDriverContact("");
  };

  const { isLoading: isAddingBlock, mutate: addTransport } = useAddTransport({
    onSuccess: () => {
      onResetTransportForm();
      dispatch(setSuccessMessage("Transport added successfully."));
    },
    onError: (err) => dispatch(setErrorMessage(parseApiError(err))),
  });

  const handleAddTransport = () => {
    if (!transportCode) {
      return dispatch(setWarningMessage("Please enter transport code."));
    }

    if (!routeName) {
      return dispatch(setWarningMessage("Please enter route name."));
    }

    addTransport({
      route_name: routeName,
      vehicle_no: vehicleNo,
      driver_name: driverName,
      driver_contact: driverContact,
      driver_license: licenseNo,
      transport_code: transportCode,
    });
  };

  return (
    <div className="flex flex-col">
      <TransportForm
        routeName={routeName}
        setRouteName={setRouteName}
        vehicleNo={vehicleNo}
        setVehicleNo={setVehicleNo}
        licenseNo={licenseNo}
        setLicenseNo={setLicenseNo}
        driverName={driverName}
        setDriverName={setDriverName}
        driverContact={driverContact}
        setDriverContact={setDriverContact}
        transportCode={transportCode}
        setTransportCode={setTransportCode}
      />

      <div>
        <Button
          loading={isAddingBlock}
          text="Save"
          onClick={handleAddTransport}
        />
      </div>
    </div>
  );
};
